import React from 'react'
import { BsLinkedin, BsTwitter, BsInstagram } from 'react-icons/bs'

const SocialMedia = () => {
    return (
        
        <div className="app__social">
            
                <a href="https://www.linkedin.com/in/anas-mohamed-aziz-najjar-400672200/">  
                <div>
                <BsLinkedin />
                </div>
                </a>
                <a href="https://www.instagram.com/njoura7">  
                <div>
                <BsInstagram />
                </div>
                </a>
                
                <a href="https://twitter.com/njoura7">  
                <div>
                <BsTwitter />
                </div>
                </a>
            
        </div>
        
    )
}

export default SocialMedia
